module.exports = __webpack_public_path__ + "static/img/pCT6.665ec149.png";